export enum ManageSystemMessagesEnum {
  DisconnectSuccess = 'was successfully disconnected!',
  DisconnectFailure = 'Location disconnect was failed!',

  CleanSuccess = 'The agent will be cleaned. Please hold on.',
  CleanFailure = 'Agent clean was failed!',

  UpdateClientSuccess = 'Selected agents will be updated. Please hold on.',
  UpdatedClientSuccess = 'Selected agents were successfully updated to the latest version.',
  UpdateClientFailure = 'Agent update failed.',

  InstallApkClientSuccess = 'DDS Signage app will be installed on the device. Please hold on.',
  InstalledApkClientSuccess = 'DDS Signage app was successfully installed on the device.',
  NoApkClientFileInfo = 'Please provide DDS Signage app path',

  UpdateScheduleSuccess = 'Schedule was successfully updated!',

  UpdateLocationTitle = 'Update Location',
  UpdateLocationSuccess = 'location was successfully updated',

  UpdateClientFileSuccess = 'The agent\'s file path was successfully updated',
  NewFilePathIs = 'New update file path is',
  TimeToOffDisplaysEqualToOn = 'Time when displays should be turned on cannot be equal to time to turn them off.',
  ClientUploadPathNullify = 'The agent`s path to update was set to the default',
  ClientUploadPathIsAlreadyDefault = 'The agent`s path is already set to the default',

  WrongFileTypeUploadingTitle = 'Wrong file type',
  WrongFileTypeUploadingDescription = 'You can upload only \'exe\' files',

  NewAgentTitle = 'New Agent',
  AgentAssignmentSuccess = 'agent was successfully added!',
  AgentAssignmentFailure = 'Failed to connect agent!',
  AndroidModeSelectorLabel = 'Android app mode',
  AndroidDisplayOrientationLabel = 'Display orientation',
  AndroidModeSelectorPlaceholder = 'Select mode',
  AndroidDisplayOrientationPlaceholder = 'Choose an orientation',

  ChangeAndroidAppModeSuccess = 'Android app mode was successfully changed!',

  LogsGatheringTitle = 'Gathering Logs',
  LogsGatheringDescription = 'The process might take a few minutes, please hold on.',

  MachineCategoryCreationTitle = 'Category creation',
  MachineCategoryCreationDescription = 'category was successfully added!',
  MachineCategoryUpdatingTitle = 'Category updating',
  MachineCategorUpdatingyDescription = 'category was successfully updated!',
  MachineCategoryDeletingTitle = 'Category deleting',
  MachineCategoryDeletingDescription = 'Category was successfully deleted!',
  MachineCategoryAssignmentTitle = 'Category assignment',
  MachineCategoryAssignmentDescription = 'Selected locations were successfully assigned to the',
  MachineCategoryDismissionTitle = 'Dismissed successfully',
  MachineCategoryDismissionDescription = 'Category assignment for selected locations were successfully dismissed',

  DDSSignageAppRestartDescription = 'DDS Signage app on the selected devices will be restarted',
  RestartDescription = 'Selected locations will be restarted',

  AgentDownloadingTitle = 'Agent Downloading',
  AgentDownloadingDescription = 'Agent will be downloaded in a few seconds'
}
